export const setTitle = pageTitle => `${pageTitle} : gatsby-starter-robin`
